import { updateProductTourStatus } from "./update"

export const productTour = {
  update: updateProductTourStatus,
}
